import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import {
  trigger,
  state,
  transition,
  style,
  animate,
} from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import Swal from 'sweetalert2';
import { RequestService } from '../../../services/http/request.service';
import { SubSink } from 'subsink';
import { LocationService } from 'src/app/services/location/location.service';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth/auth.service';

const HOME_KEY = 'homeCache';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate(300)]),
      transition(':leave', [animate(500)]),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  loading: boolean = false;
  unsubscribe$ = new SubSink();
  most_viewed: Array<any> = [];
  new_release: Array<any> = [];
  recommended: Array<any> = [];
  top_rated: Array<any> = [];
  limited_time: Array<any> = [];
  best_sellers: Array<any> = [];
  lat;
  lng;

  constructor(
    @Inject(DOCUMENT) document,
    private request: RequestService,
    private locationService: LocationService,
    private titleService: Title,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      'Online Shopping Site for Mobiles, Electronics, Furniture, Grocery, Lifestyle, Books &amp; More. Best Offers! | Pantehia.com'
    );
    this.getUserLocation();
  }

  getUserLocation() {
    this.unsubscribe$.add(
      this.locationService.location$.subscribe((res) => {
        if (res) {
          this.lat = res.lat;
          this.lng = res.lng;
          this._fetchData();
        }
      })
    );
  }
  _fetchData(): void {
    const user_id = this.auth.getUser();
    console.log('tis is ', this.lat, this.lng, user_id);
    this.loading = true;
    this.unsubscribe$.add(
      this.request
        .POST('home', { lat: this.lat, lng: this.lng, user_id })
        .subscribe(
          (response) => {
            console.log('home--> ', response);

            if (response['status']) {
              this.loading = false;
              this.most_viewed = response['products'].most_viewed;
              this.new_release = response['products'].new_releases;
              this.recommended = response['products'].recommended;
              this.top_rated = response['products'].top_rated;
              this.limited_time = response['products'].limited_time_deals ?? [];
              this.best_sellers = response['products'].top_sellers ?? [];
            } else {
              this.loading = false;
              Swal.fire('Error', response.message, 'error');
            }
          },
          (err) => {
            this.loading = false;
          }
        )
    );
  }

  //destroy components
  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }
}
